import * as exercisesConstants from './exercises';
export var exercises = exercisesConstants;
export var issueCategories = [{
  key: 'video-broken',
  value: "The video doesn't work properly"
}, {
  key: 'typo-video',
  value: 'There is a typo in this video'
}, {
  key: 'other',
  value: 'Other'
}];